import api from './api';

export const contributionService = {
  previewSchedule: (data) => api.post('/contributions/preview-schedule/', data),
  createPlan: (data) => api.post('/contributions/plans/', data),
  getMyPlans: (params) => api.get('/contributions/plans/', { params }),
  getPlan: (id) => api.get(`/contributions/plans/${id}/`),
  getSchedule: (id) => api.get(`/contributions/plans/${id}/schedule/`),
  contribute: (id, data) => api.post(`/contributions/plans/${id}/contribute/`, data),
  getPaymentHistory: (id) => api.get(`/contributions/plans/${id}/payments/`),
  getTrustScore: () => api.get('/contributions/trust-score/'),
  getProgressCardQuote: (id) => api.get(`/contributions/plans/${id}/progress-card/quote/`),
  requestProgressCard: (id, data) => api.post(`/contributions/plans/${id}/progress-card/`, data),
  getPlanAdvanceQuote: (id) => api.get(`/contributions/plans/${id}/plan-advance/quote/`),
  requestPlanAdvance: (id, data) => api.post(`/contributions/plans/${id}/plan-advance/request/`, data),
};

export const adminContributionService = {
  getPlans: (params) => api.get('/contributions/admin/plans/', { params }),
  getPlan: (id) => api.get(`/contributions/admin/plans/${id}/`),
  getPendingPlanAdvances: (params) => api.get('/contributions/admin/queue/pending-plan-advances/', { params }),
  executePlanAdvance: (id) => api.post(`/contributions/admin/plan-advance/${id}/execute/`),
};
